import { clusterStore } from '@entities/cluster'
import { useSession } from '@entities/session'
import { useEffect } from 'react'
import { useAction, useAppSelector } from '@shared/lib/redux'

import { mapStore } from '@components/map'

export const useObserveMapLayers = () => {
  const { isAuthorized } = useSession()
  const getClusters = useAction(clusterStore.actions.getClustersStart)
  const mapBounds = useAppSelector(mapStore.selectors.selectMapBounds)
  const { zoom } = useAppSelector(mapStore.selectors.selectMapCommon)

  useEffect(() => {
    if (isAuthorized) {
      getClusters({ zoomLevel: zoom, ...mapBounds })
    }
  }, [mapBounds, zoom, isAuthorized, getClusters])
}

export const useSetSelectedCluster = () => {
  return useAction(clusterStore.actions.setSelectedCluster)
}
